import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

export const getElectricalOutlets = createAsyncThunk('get/electicalOutlet', async () => {
  const response = await axios.get('/electrical-outlet/');
  return response.data;
});

export const addElectricalOutlet = createAsyncThunk(
  'add/electricalOutlet',
  async (ElectricalOutlet, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/electrical-outlet/', ElectricalOutlet);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateElectricalOutlet = createAsyncThunk(
  'update/electrical-outlet',
  async ({ idOutlet, ElectricalOutlet }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/electrical-outlet/${idOutlet}/`, ElectricalOutlet);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteElectricalOutlet = createAsyncThunk(
  'delete/electricalOutlet',
  async (idOutlet, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/electrical-outlet/${idOutlet}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteManyElectricalOutlets = createAsyncThunk(
  'deleteMany/electricalOutlet',
  async (outletIDs, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/electrical-outlet/delete_many/', { data: { arrId: outletIDs } });
      dispatch(getElectricalOutlets());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const outletAdapter = createEntityAdapter({});

const eletricalOutletSlice = createSlice({
  name: 'eletrical',
  initialState: {
    loading: false,
    isSubmitting: false,
    outlets: [],
    searchText: '',
    routeParams: {},
  },
  reducers: {
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
  },

  extraReducers: {
    [getElectricalOutlets.pending]: (state) => {
      state.loading = true;
    },
    [getElectricalOutlets.fulfilled]: (state, action) => {
      const {data} = action.payload;
      state.outlets = data;
      state.loading = false;
    },
    [getElectricalOutlets.rejected]: (state) => {
      state.loading = false;
    },
    // ---------------------------------------------
    [addElectricalOutlet.pending]: (state) => {
      state.isSubmitting = true;
    },

    [addElectricalOutlet.fulfilled]: (state) => {
      state.isSubmitting = false;
    },

    [addElectricalOutlet.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // -----------------------------------------------
    [updateElectricalOutlet.pending]: (state) => {
      state.isSubmitting = true;
    },

    [updateElectricalOutlet.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateElectricalOutlet.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ---------------------------------------------------
    [deleteElectricalOutlet.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteElectricalOutlet.rejected]: (state) => {
      state.isSubmitting = false;
    },
    [deleteElectricalOutlet.pending]: (state) => {
      state.isSubmitting = true;
    },
    // ---------------------------------------------------
    [deleteManyElectricalOutlets.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyElectricalOutlets.rejected]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyElectricalOutlets.pending]: (state) => {
      state.isSubmitting = true;
    }

  },
});

export const {
  openNewEletricalDialog,
  closeNewEletricalDialog,
  openEditEletricalDialog,
  closeEditEletricalDialog,
  setSearchText,
} = eletricalOutletSlice.actions;

export default eletricalOutletSlice.reducer;
